import { Close } from "@mui/icons-material";
import { Box, Dialog, Grid, IconButton, Typography } from "@mui/material";

type CustomDialogProps = {
    open: boolean;
    onClose: Function;
    children: React.ReactNode;
    title: string; // Optional title prop
    maxWidth?: "xs" | "sm" | "md" | "lg" | "xl"; // Optional maxWidth prop
};

function CustomDialog({ open, onClose, children, title, maxWidth }: CustomDialogProps) {
    return (
        <>
        <Dialog open={open} onClose={() => onClose} fullWidth maxWidth={maxWidth || "md"}>
            <Grid container sx={{ padding: 2, display: 'flex', justifyContent: 'flex-start' }} >
                <Grid item xs={11}>
                    <Typography variant="h5">{title}</Typography>
                </Grid>
                <Grid item xs={1} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <IconButton onClick={() => onClose(false)}>
                        <Close />
                    </IconButton>
                </Grid>
            </Grid>
        <Box sx={{ padding: 2 }}>
            {children}
        </Box>
        </Dialog>
        </>
    );
}

export default CustomDialog;